import React from 'react';
import { createPortal } from 'react-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationDialog = ({ isOpen, onClose, onConfirm, file, isDeleting }) => {
  if (!isOpen || !file) return null;

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes?.[i];
  };

  return createPortal(
    <div className="modal-overlay animate-fade-in" onClick={onClose}>
      <div className="modal-content max-w-md animate-scale-in" onClick={(e) => e?.stopPropagation()}>
        <div className="modal-header">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-error/10 flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-error" />
            </div>
            <h2 className="modal-title">Delete File</h2>
          </div>
        </div>

        <div className="modal-body">
          <p className="text-sm text-foreground mb-4">
            Are you sure you want to delete this file? This action cannot be undone.
          </p>

          <div className="bg-muted rounded-lg p-4 space-y-3">
            <div className="flex items-start gap-3">
              <Icon name="File" size={20} className="text-muted-foreground flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground break-all mb-1">
                  {file?.name}
                </p>
                <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
                  <span className="font-mono">{formatFileSize(file?.size)}</span>
                  <span>•</span>
                  <span>{file?.type}</span>
                </div>
              </div>
            </div>

            {file?.path && (
              <div className="pt-3 border-t border-border">
                <p className="text-xs text-muted-foreground mb-1">S3 Path</p>
                <p className="text-xs font-medium text-foreground font-mono break-all">
                  {file?.path}
                </p>
              </div>
            )}
          </div>

          <div className="mt-4 p-3 bg-error/5 border border-error/20 rounded-md">
            <div className="flex gap-2">
              <Icon name="AlertCircle" size={16} className="text-error flex-shrink-0 mt-0.5" />
              <p className="text-xs text-error">
                This file will be permanently deleted from your S3 bucket and cannot be recovered.
              </p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            loading={isDeleting}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete File
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmationDialog;